import { useSyncExternalStore } from 'react';
import { useBeforeUnload } from './useBeforeUnload';
import { isAnyClipUpdating, pendingEditsStore } from '@/stores/pendingEditsStore';

export const usePendingEditsConfirm = () => {
  const pendingEdits = useSyncExternalStore(pendingEditsStore.subscribe, pendingEditsStore.getSnapshot);
  const isAnyClipUpdateInProgress = isAnyClipUpdating(pendingEdits);
  useBeforeUnload({ shouldPrompt: isAnyClipUpdateInProgress });
};
